import { useEffect, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { request } from '../helpers/request';
import Loader from '../components/Loader';
import Paper from '@material-ui/core/Paper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useAlert } from 'react-alert'

const Clients = () => {
  const alert = useAlert();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState({
    client: {}
  });
  const [stripeInformation, setStripeInformation] = useState({
    paymentMethodsCard: [],
    paymentMethodsSEPA: []
  });

  const getAllClients = async () => {
    setLoading(true);
    const { data } = await request.get('/clients');
    setClients(data);
    setLoading(false);
  }

  const onClickClient = async contact => {
    try {
      setLoading(true);
      const { data } = await request.get(`/clients/${(contact.client || {}).id}`);
      console.log(contact)
      console.log(data)
      setLoading(false);
      setSelectedClient(contact);
      setStripeInformation(data.stripeCustomer);
      setShow(true);
    } catch(e) {
      setLoading(false);
      alert.error("Hubo un error cargando el usuario")
    }
  }

  const formSubmit = async (event) => {
    event.preventDefault();
    setLoadingRequest(true);
    const data = {};
    const inputs = event.target.querySelectorAll('input');
    for (var i in inputs) {
      data[inputs[i].name] = inputs[i].value;
    }
    try {
      await request.post('/clients', {
        name: selectedClient.name,
        company_name: selectedClient.tradeName,
        holdedId: selectedClient.id,
        sepa: data.sepa,
        email: selectedClient.email,
      });
      setShow(false);
      setLoadingRequest(false)
      getAllClients();
    } catch (e) {
      setLoadingRequest(false);
    }
  }

  useEffect(() => {
    getAllClients();
  }, [])

  return (
    <div>
      {/* <Button onClick={() => setShow(true)} variant="contained" color="primary">Crear Cliente</Button>{' '} */}
      {/* <br />
      <br /> */}
      {loading && <Loader isLoading={true} />}
      {!loading && <TableContainer component={Paper}>
        <Table striped bordered hover>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Nombre</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Teléfono</TableCell>
              <TableCell>Stripe</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              clients.map(client => (
                <TableRow className="table-hover-tr" key={client.id}>
                  <TableCell>
                    <CopyToClipboard text={(client.client || {}).id || 'Sin asignar'}
                      onCopy={() => alert.info("Copiado")}>
                      <span className="copy-clipboard-client-name">{(client.client || {}).id || 'Sin asignar'}</span>
                    </CopyToClipboard>
                  </TableCell>
                  <TableCell onClick={() => onClickClient(client)}>{client.name} {client.lastname}</TableCell>
                  <TableCell onClick={() => onClickClient(client)}>{client.email}</TableCell>
                  <TableCell onClick={() => onClickClient(client)}>{client.phone}</TableCell>
                  <TableCell onClick={() => onClickClient(client)}>{(client.client || {}).stripeId ? <FontAwesomeIcon color="green" icon={faCheck} /> : <FontAwesomeIcon color="red" icon={faTimes} />}</TableCell>
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </TableContainer>
      }


      <Modal show={show} onHide={() => setShow(false)}>
        <Form onSubmit={formSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Información de {selectedClient.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Para usar nuevos metodos de pago el usuario debe añadirlos haciendo un pago manual, a partir de ahí quedarán disponibles para cobro automático</p>

            <p><b>Número de cliente para pagos:&nbsp;&nbsp;</b>
              <CopyToClipboard text={(selectedClient.client || {}).id || 'Sin asignar'}
                onCopy={() => alert.info("Copiado")}>
                <span className="copy-clipboard-client-name">{(selectedClient.client || {}).id || 'Sin asignar'}</span>
              </CopyToClipboard>
            </p>
            
            {
              (stripeInformation.paymentMethodsCard || []).length > 0 || (stripeInformation.paymentMethodsSEPA || []).length > 0?
                <p><b>Métodos de pago disponibles</b></p>
              :
                <p><b>El cliente aún no tiene configurados ningún método de pago</b></p>
            }
            
            
            {(stripeInformation.paymentMethodsCard || []).length > 0 && <p><img alt="logo-card" style={{ marginRight: 7, width: 60 }} src="https://upload.wikimedia.org/wikipedia/commons/1/16/Former_Visa_%28company%29_logo.svg" />Tarjetas</p>}
            <ul>
              {
                (stripeInformation.paymentMethodsCard || []).map(info => <li>••••{info.card.last4}</li>)
              }
            </ul>
            {(stripeInformation.paymentMethodsSEPA || []).length > 0 && <p><img alt="logo-sepa" style={{ width: '40px', marginRight: '9px' }} src={"data:image/png;base64,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"} />IBAN</p>}
            <ul>
              {
                (stripeInformation.paymentMethodsSEPA || []).map(info => <li>••••{info.sepa_debit.last4}</li>)
              }
            </ul>
          </Modal.Body>
          {!((selectedClient || {}).client || {}).stripeId && <Modal.Footer>
            {
              loadingRequest ?
                "Creando..."
                :
                <>
                  <Button onClick={() => setShow(false)}>
                    Cancelar
                  </Button>
                  <Button variant="contained" color="primary" type="submit">
                    Crear
                  </Button>
                </>
            }
          </Modal.Footer>}
        </Form>
      </Modal>

    </div>
  );
}

export default Clients;
